import classnames from 'classnames'
import React from 'react'

import { Button, Icon } from '..'

interface Props {
  label?: string
  href: string | undefined
  isBold?: boolean
  className?: string
}

export function ExternalLink({ label, href, isBold, className }: Props) {
  return (
    <Button
      as="a"
      rightContent={<Icon name="openInNew" className="text-disabled group-hover/button:text-inherit" width={12} />}
      size="none"
      padding="xxsmall"
      theme="linkText"
      className={classnames('inline-flex text-2xs leading-none', className)}
      target="_blank"
      rel="nofollow"
      href={href}
      onMouseDown={(event: React.MouseEvent<HTMLAnchorElement>) => event.stopPropagation()}
      onClick={(event: React.MouseEvent<HTMLAnchorElement>) => event.stopPropagation()}
    >
      {label && <span className={classnames({ 'font-bold': isBold })}>{label}</span>}
    </Button>
  )
}
